//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { analytics } from "/src/main.js";
export default {
  name: "Classes",
  watch: {
    loaded() {
      var component = this
      this.$nextTick(() => {
        var observer = new IntersectionObserver(function (entries) {
          if (entries[0]["isIntersecting"]) {
            component.loadNext()
          }
        });
        observer.observe(this.$refs.bottom);
      });
    },
  },
  data() { 
    return {
      loaded: false,
      displayCount: 9,
      currentFilter: "All",
      allStyles: ["All", "Latin", "Standard", "Smooth", "Rhythm"],
    };
  },
  computed: {
    allClassesArray() {
      return this.loaded
        ? this.$store.state.classesArray.filter((value) => value.hidden != true)
        : null;
    },
    displayedClasses() {
      return this.allClassesArray.slice(0, this.displayCount-1)
    },
    filteredClasses() {
      return this.loaded
        ? this.currentFilter === "All"
          ? this.allClassesArray
          : this.allClassesArray.filter(
              (value) => value.style === this.currentFilter
            )
        : null;
    },
  },
  methods: {
    loadNext() {
      this.displayCount = this.displayCount + 9
    }
  },
  async created() {
    await this.$store.dispatch("setClasses");
    await this.$store.dispatch("setInstructors");
    this.loaded = true;
    analytics.logEvent("screen_view", {
      firebase_screen: "/classes",
      firebase_screen_class: "screenClass",
    });
  },
};
